module.exports = __webpack_public_path__ + "img/close.4f06de54.svg";